import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import { Logo, Avatar, MCButton } from 'src/components/basic';
import SVGIcon, { GENERAL_ICONS, BASE_ICONS } from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import {
  lang,
  upperFirstCharAll,
  scssVariables,
  permissions,
  isAdminPage,
  userFullName,
  withRouter
} from 'src/helpers';

import model from 'src/model';
import { popupModel } from './complex';
import constants from '../constants';
import AlertManager from './alert/AlertManager';
import LANG_CONST from '../helpers/lang/const';
import { UnreadBadge } from './basic/UnreadBadge';

class DrawerMenu extends BaseComponent {
  state = {
    accountsListOpen: false
  };

  componentDidMount() {
    if (!document.body.classList.contains('mc-drawermenu-minimize') && model.state.isMiniMenu) {
      document.body.classList.toggle('mc-drawermenu-minimize');
    }
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  handleToggleSidebar = () => {
    document.body.classList.toggle('mc-drawermenu-minimize');
    document.body.classList.toggle('mc-asideOpen');
    let isMiniMenu = document.body.classList.contains('mc-drawermenu-minimize');
    model.setState({
      isMiniMenu
    });
    if (isMiniMenu) {
      this.setState({ accountsListOpen: false });
    }
  };

  switchAccount = (id) => {
    // this.setState({ accountsListOpen: false });
    model.emit('switchAccount', id);
  };

  getUnreadCounter = (acc, unreadCounters) => {
    if (!unreadCounters) unreadCounters = model.state.unreadCounters || [];
    let counter = (unreadCounters.find((c) => c.id == acc.id) || { unread: 0 }).unread || 0;
    if (counter < 0) counter = 0;
    if (counter > 99) counter = '99+';
    return counter;
  };

  getAccLabel = (acc, user) => {
    return acc?.clinicName && acc?.role?.includes('manager')
      ? lang.t(LANG_CONST.manager_at, {
          name: upperFirstCharAll(acc?.clinicName)
        })
      : acc.username
        ? upperFirstCharAll(acc.username)
        : (acc.role == 'doctor' ? 'Dr.' : '') + user.username;
  };

  getAccSublabel = (acc) => {
    let sublabel = '';
    if (acc.role == 'doctor' && !acc.clinicName) {
      sublabel = 'Independent';
    } else if (acc.clinicName) {
      if (acc.role == 'manager') {
        sublabel = `manager ${acc.clinicName}`;
      } else {
        sublabel = acc.clinicName;
      }
    }
    return sublabel;
  };

  deleteAccount = () => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete_account,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        loadingLabel: LANG_CONST.buttons.processing,
        action: (actions) => {
          actions.setLoading(true);
          model.removeAccount((err, res, success) => {
            actions.setLoading(false);
            if (success) {
              actions.hide();
            } else {
              alert(`error: ${err}`);
            }
          });
        }
      }
    });
  };

  render() {
    let { isSettings, user, menu: list = [] } = this.props;
    let isMiniMenu = !!model.getState().isMiniMenu;
    let connectedAccounts = !model.state.tempLoginInfo && ((user && user.connectedAccounts) || []);

    let unreadCounters = model.state.unreadCounters || [];
    if (unreadCounters?.length > 0 && connectedAccounts?.length > 0) {
      connectedAccounts.forEach((acc) => {
        acc.unread = this.getUnreadCounter(acc, unreadCounters);
      });
    }

    const activeAccount = ((user && user.connectedAccounts) || [])?.find((a) => a.id === user.id);
    if (activeAccount) {
      activeAccount.unread = this.getUnreadCounter(activeAccount, unreadCounters);
    }

    let { accountsListOpen } = this.state;

    const verified = ![
      constants.general.userStatus.pending,
      constants.general.userStatus.declined,
      constants.general.userStatus.updated
    ].includes(user.status);

    let avatar = (user?.avatar || '').toString().replace('/full_', '/350_');
    let name = userFullName(user);
    if (isMiniMenu)
      name = (user?.firstName || ' ')[0].toUpperCase() + (user?.lastName || ' ')[0].toUpperCase();

    return (
      <div className='mc-drawerMenu'>
        <div className='mc-drawerMenu-header'>
          <div className='mc-drawerMenu-logo'>
            <Link to='/'>
              {' '}
              <Logo logoProps={{ width: 40, height: 40 }} />{' '}
            </Link>
          </div>
          <div className='mc-toggleBtn' onClick={() => this.handleToggleSidebar()}>
            <SVGIcon iconname={GENERAL_ICONS.TOGGLE_MENU} />
          </div>
        </div>
        <div className='mc-menuBox'>
          <ul className='mc-sidebar-menu'>
            {!isSettings && model.state.tempLoginInfo && (
              <li className='mc-sidebar-menu-item mc-flex-col'>
                <MCButton
                  primary
                  flex
                  type={'button'}
                  onClick={() => {
                    popupModel.setActivePopup('loading', {
                      active: true
                    });
                    const isAdmin = model.state.tempLoginInfo.subType.includes('admin');
                    if (isAdmin) {
                      permissions.switchToAdmin();
                    }
                    model.backPreviousAccount(
                      model.state.tempLoginInfo,
                      model.state.tempLoginInfo?.url
                        ? { url: model.state.tempLoginInfo?.url }
                        : isAdmin && { url: '/admin/' },
                      () => {
                        popupModel.setActivePopup('loading', { active: false });
                      }
                    );
                  }}
                  label={lang.t(LANG_CONST.back_to, {
                    name: model.state.tempLoginInfo.subType.includes('admin')
                      ? 'Admin'
                      : model.state.tempLoginInfo.name
                  })}
                />
              </li>
            )}
            {!isSettings && connectedAccounts.length > 1 && (
              <li className='mc-sidebar-menu-item'>
                <div
                  className={`mc-sidebar-menu-item-link mc-sidebar-menu-account`}
                  onClick={() => {
                    this.setState({ accountsListOpen: !accountsListOpen });
                    if (document.body.classList.contains('mc-drawermenu-minimize'))
                      document.body.classList.toggle('mc-drawermenu-minimize');
                  }}
                >
                  <div className='mc-sidebar-menu-item-link-icon'>
                    <Avatar
                      text={user.firstName}
                      width={50}
                      height={50}
                      image={(user.avatar || '').replace('/full_', '/350_')}
                    />
                  </div>
                  <span
                    className='mc-sidebar-menu-item-link-text'
                    style={{ flex: 1, textOverflow: 'ellipsis', overflow: 'hidden' }}
                  >
                    {activeAccount?.role?.includes('manager') && activeAccount?.clinicName
                      ? lang.t(LANG_CONST.manager_at, {
                          name: upperFirstCharAll(activeAccount?.clinicName)
                        })
                      : activeAccount?.username
                        ? upperFirstCharAll(activeAccount?.username)
                        : (user.isDoctor ? 'Dr.' : '') + user.username}
                  </span>
                  <span className='mc-sidebar-menu-item-link-text'>
                    <SVGIcon
                      iconname={accountsListOpen ? BASE_ICONS.UP : BASE_ICONS.DOWN}
                      width={20}
                      fill={scssVariables['colors-mc-text-light']}
                    />
                  </span>
                </div>
              </li>
            )}
            {!isSettings && connectedAccounts.length > 1 && (
              <div
                className={`mc-sidebar-menu-account-container ` + (accountsListOpen ? 'open' : '')}
              >
                {connectedAccounts.map((acc) => {
                  let accLabel = this.getAccLabel(acc, user);
                  let sublabel = this.getAccSublabel(acc, user);
                  let unread = acc.unread;
                  // unread = 5;
                  return (
                    <li className='mc-sidebar-menu-item' key={acc.id}>
                      <div
                        className={
                          `mc-sidebar-menu-item-link mc-sidebar-menu-account ` +
                          (acc.id === user.id ? 'active' : '')
                        }
                        onClick={() => this.switchAccount(acc.id)}
                      >
                        <div className='mc-sidebar-menu-item-link-icon'>
                          <Avatar
                            text={user.firstName}
                            width={50}
                            height={50}
                            image={(acc.id === user.id ? user.avatar : acc.avatar)?.replace(
                              '/full_',
                              '/350_'
                            )}
                            userId={acc.id}
                          />
                        </div>
                        <div className='mc-sidebar-menu-item-link-container'>
                          <div className='mc-sidebar-menu-item-link-text-subacc mc-flex1 mc-text-truncate'>
                            {accLabel}
                          </div>
                          {!!sublabel && (
                            <div className='mc-sidebar-menu-item-link-sublabel mc-flex1 mc-text-truncate'>
                              {sublabel}
                            </div>
                          )}
                        </div>
                        <UnreadBadge unread={unread} />
                      </div>
                    </li>
                  );
                })}
              </div>
            )}
            {!isSettings && !isAdminPage() && (user.isDoctor || user?.isClinic) ? (
              <li className='mc-sidebar-menu-item'>
                <div
                  className={'mc-sidebar-menu-item-link active mc-pointer'}
                  style={{ backgroundColor: 'white' }}
                  onClick={() => {
                    if (!verified)
                      AlertManager.popup(AlertManager.TYPES.INFO, {
                        title: LANG_CONST.notice.account_verifying,
                        actionButton: {
                          label: LANG_CONST.buttons.ok,
                          action: ({ hide }) => hide()
                        }
                      });
                  }}
                >
                  <div className={'mc-sidebar-menu-item-link-icon'}>
                    <SVGIcon
                      iconname={GENERAL_ICONS.VERIFY}
                      width={40}
                      height={40}
                      fill={scssVariables[`colors-mc-${verified ? 'primary' : 'quaternary'}`]}
                    />
                  </div>
                  <span
                    className='mc-sidebar-menu-item-link-text'
                    style={{
                      color: scssVariables[`colors-mc-${verified ? 'primary' : 'quaternary'}`]
                    }}
                  >
                    {lang.t(verified ? LANG_CONST.verified : LANG_CONST.not_verified)}
                  </span>
                </div>
              </li>
            ) : null}
            {isSettings && (
              <div className={'mc-menu-info mc-p20'}>
                <div className={'mc-flex-10-col mc-flex-center'}>
                  <Avatar
                    image={avatar}
                    text={name}
                    width={isMiniMenu ? 50 : 90}
                    height={isMiniMenu ? 50 : 90}
                  />
                  <div className={'mc-value-620'}>{name}</div>
                  {/*{user.username && <div className={'mc-label-418'}>{user.username}</div>}*/}
                </div>
                {/*<div className={'mc-flex-10-col'} style={{ width: '100%' }}>*/}
                {/*  {user.phoneNumber && (*/}
                {/*    <div className={'mc-flex'}>*/}
                {/*      <div className={'mc-value-418 mc-grow'}>{lang.t(LANG_CONST.phone)}</div>*/}
                {/*      <div className={'mc-label-418 mc-text-truncate'}>*/}
                {/*        {formatPhoneNumberIntl(user.phoneNumber.toString())}*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  )}*/}
                {/*  <div className={'mc-flex mc-b2t mc-pt10'}>*/}
                {/*    <div className={'mc-value-418 mc-grow'}>{lang.t(LANG_CONST.email)}</div>*/}
                {/*    <div className={'mc-label-418 mc-text-truncate'}>{user.email}</div>*/}
                {/*  </div>*/}
                {/*</div>*/}
              </div>
            )}
            {list.map((item, index) => {
              const navPath = item.navPath || item.path;
              return (
                <li className='mc-sidebar-menu-item' key={index}>
                  <NavLink
                    to={navPath}
                    className={({ isActive }) =>
                      `mc-sidebar-menu-item-link ` +
                      (isActive || (item.isActiveEx && item.isActiveEx()) ? 'active' : '')
                    }
                    exact={'true'}
                    onClick={(e) => {
                      if (item.beforeClick) {
                        e.preventDefault();
                        if (item.beforeClick({ auth: model.state.user })) {
                          this.navigate(navPath);
                        }
                      }
                      setTimeout(() => {
                        document.body.classList.remove('mc-asideOpen');
                      }, 100);
                    }}
                  >
                    <div className='mc-sidebar-menu-item-link-icon'>
                      <SVGIcon iconname={item.icon} width={40} height={40} />
                    </div>
                    <span className='mc-sidebar-menu-item-link-text mc-grow'>
                      {lang.t(typeof item.title === 'string' ? item.title : item.title(user))}
                    </span>
                    {!!activeAccount?.unread && item.title === 'Messages' && (
                      <UnreadBadge unread={activeAccount?.unread} />
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}
export default withRouter(DrawerMenu);
